import React from "react";

const ASSET_BASE = "https://customer-assets.emergentagent.com/job_dd09531f-668a-4a0d-a0ca-bed81cccc9a3/artifacts";
export const LOGO_LIGHT_BG = `${ASSET_BASE}/oca36vp6_Main%20Logo.png`;     // black text + colored mark → use on LIGHT bg
export const LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_ebikego-preview/artifacts/h67t87sy_ebikego%20logo.png"; // white text + colored mark → use on DARK bg
export const LOGO_ICON = `${ASSET_BASE}/gum5c89l_Icon.png`;                // mark only (green/blue)

export const LogoMark = ({ size = 28, className = "" }) => (
  <img
    src={LOGO_ICON}
    alt="eBikeGo"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);

export const Logo = ({ dark = false, height = 30 }) => (
  <img
    src={dark ? LOGO_DARK_BG : LOGO_LIGHT_BG}
    alt="eBikeGo"
    className="object-contain select-none"
    style={{ height, width: "auto", maxWidth: "180px" }}
    data-testid="brand-logo"
    draggable={false}
  />
);
